import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { getActivePlayers } from '../../../actions'

class PlayersStats extends Component {
  render () {
    const { players } = this.props
    const invited = players.filter(p => p.attending_status === 'invited')
    const active = players.filter(p => p.attending_status === 'active')
    const arrived = players.filter(p => p.attending_status === 'arrived')
    // const activePlayers = players.filter(p => p.active)
    // const city = players && players[0].location.split(' ')[0]

    return [
      <div className='dashboard-teams-row' key='1'>
        <div className='cell-subject'>Players</div>
        <div className='cell-tags cell-looking-for'>
          {players.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='2' >
        <div className='cell-subject unset-text-transform'>Invited</div>
        <div className='cell-tags cell-looking-for'>
          {invited.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='3' >
        <div className='cell-subject unset-text-transform'>Active</div>
        <div className='cell-tags cell-looking-for'>
          {active.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='4' >
        <div className='cell-subject unset-text-transform'>Arrived</div>
        <div className='cell-tags cell-looking-for'>
          {arrived.length}
        </div>
      </div>
    ]
  }
}

const mapStateToProps = (state) => {
  return {
    players: state.participants
  }
}

export default connect(mapStateToProps)(PlayersStats)



// WEBPACK FOOTER //
// ./src/screens/administration/statistics/PlayersStats.js